import { useAuth } from '@/shared/auth/useAuth';
import { messageOf } from '@/shared/api/problem';
import { DOCUMENTS, formatDay, useAcceptDocuments, usePendingDocuments } from './api';

/**
 * Okienko po zmianie regulaminu albo polityki prywatności — dla zalogowanych, którzy nowej wersji jeszcze nie
 * zaakceptowali: wykaz zmian, link do pełnej treści i przycisk akceptacji (zapisywanej w rejestrze akceptacji).
 * Poza routerem (dostawcy kontekstu) — dlatego zwykłe linki.
 */
export function LegalChanges() {
  const { state } = useAuth();
  const pending = usePendingDocuments(state.status === 'authenticated');
  const accept = useAcceptDocuments();
  const docs = state.status === 'authenticated' ? (pending.data ?? []) : [];
  if (docs.length === 0) return null;
  const names = docs.map((d) => DOCUMENTS[d.kind].label.toLowerCase());
  const title = `Zmiana: ${names.join(' i ')}`;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="card max-h-[90dvh] w-full max-w-lg space-y-4 overflow-y-auto p-6"
      >
        <h2 className="text-xl">Zmieniliśmy {names.join(' i ')}</h2>
        {docs.map((d) => (
          <section key={d.kind} aria-label={DOCUMENTS[d.kind].label} className="space-y-1 text-sm">
            <h3 className="font-semibold">
              {DOCUMENTS[d.kind].label} — wersja {d.version}, obowiązuje od {formatDay(d.effectiveFrom)}
            </h3>
            <p className="text-ink-2 whitespace-pre-line">{d.changes}</p>
            <a
              href={`${DOCUMENTS[d.kind].path}?wersja=${String(d.version)}`}
              target="_blank"
              rel="noreferrer"
              className="font-semibold underline"
            >
              Przeczytaj pełną treść
            </a>
          </section>
        ))}
        {accept.isError && (
          <p role="alert" className="text-sm text-red-700">
            {messageOf(accept.error)}
          </p>
        )}
        <button
          type="button"
          className="btn btn-ink w-full"
          disabled={accept.isPending}
          autoFocus
          onClick={() => {
            accept.mutate(docs);
          }}
        >
          Akceptuję
        </button>
      </div>
    </div>
  );
}
